import axios from 'axios'

import type { components, operations } from '../constants/schema'

type GetTermsListParams = Required<operations['TermsController_findByPageName']['parameters']>['path']
type GetTermsApprovedParams = Required<
  operations['UserController_getCurrentUserTermsApprovedByPageName']['parameters']
>['path']
type ToggleTermsParams = Required<operations['UserController_toggleCurrentUserTermsByPageName']['parameters']>['path']

/**
 * 페이지별 약관 목록
 * @param pageName 페이지 이름
 * @returns TermsDto[]
 */
export const getTermsList = async (pageName: GetTermsListParams['pageName']) => {
  return (await axios.get<components['schemas']['TermsDto'][]>(`/terms/page/${pageName}`)).data
}

/**
 * 약관 상세
 * @param termsId 약관 id
 * @returns TermsDto
 */
export const getTermsDetail = async (termsId: number) => {
  return (await axios.get<components['schemas']['TermsDto']>(`/terms/${termsId}`)).data
}

/**
 * 로그인 유저 페이지별 선택 약관 전체동의 여부 확인
 * @param pageName 페이지 이름
 * @returns ResBooleanResult
 */
export const getTermsApproved = async (pageName: GetTermsApprovedParams['pageName']) => {
  return (await axios.get<components['schemas']['ResBooleanResult']>(`/user/current/terms/page/${pageName}/approved`))
    .data
}

/**
 * 로그인 유저 페이지별 선택 약관 토글
 * @param pageName 페이지 이름
 * @returns ResBooleanResult
 */
export const toggleTerms = async (pageName: ToggleTermsParams) => {
  try {
    return (await axios.post<components['schemas']['ResBooleanResult']>(`/user/current/terms/page/${pageName}/toggle`))
      .data
  } catch (error) {
    throw error
  }
}
